import React, { Component } from "react";
import ReactModal from "react-modal";
import MerchantInfo from "../../shared/merchant-info/merchant-info";
import "./sendToServiceConfirm.scss";
import Loader from "../../loader/loader";
import { EmsBankFiles } from '../../../api';
import EmsFileSelectModal from '../select-ems-files-modal/emsFileSelectModal';

export default class SendToServiceConfirmModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      export_size: "all",
      showFileSelectModal: false,
      selectedFiles: null,
      loading: true
    };
  }

  componentDidMount() {
    // Fetch data only the first time
    if (this.state.selectedFiles === null) {
      this.getEmsBankFiles(this.props.appData.id);
    }
    else {
      this.setState({ loading: false }); // No need to fetch, set loading to false
    }
  }

  // Asynchronous function to fetch EMS bank files
  getEmsBankFiles = async (powerapp_id) => {
    try {
      const res = await EmsBankFiles(powerapp_id); // Fetch files from API

      if (res.data) {
        // Transform array into an object with true values
        const filesObject = res.data.reduce((acc, file) => {
          acc[file] = true;
          return acc;
        }, {});
        // Update state with fetched data
        this.setState({ selectedFiles: filesObject });
      }
    } catch (error) {
      console.error("Error fetching EMS bank files:", error);
    }
    finally {
      this.setState({ loading: false }); // Stop loading on error
    }
  };

  updateSelectedFiles = (updatedFiles) => {
    this.setState({ selectedFiles: updatedFiles, showFileSelectModal: false });
  };

  closeFileSelectModal = () => {
    this.setState({ showFileSelectModal: false });
  };

  render() {
    return (
      <ReactModal isOpen={this.props.show} className="send-confirm-modal application-page">
        <div class="modal-inner">
          <div className="modal-header">
            <h4 className="text-left">Merchant Info</h4>
            <span>Please read the details before proceed Ok.</span>
          </div>
          <div className="modal-body">
            {(this.props.service == 'ems' && this.state.selectedFiles) && <button type="button" className="btn confirm-button btn-primary" onClick={() => this.setState({ showFileSelectModal: true })}>Select Files</button>}
            {this.state.selectedFiles && <EmsFileSelectModal selectedFiles={this.state.selectedFiles} onUpdateHandler={this.updateSelectedFiles} onCloseHandler={this.closeFileSelectModal} show={this.state.showFileSelectModal} />}
            <MerchantInfo sendToService={true} appData={this.props.appData} />
          </div>
          <div className="modal-footer">
            <button type="button" className="btn confirm-button btn-primary" onClick={() => this.props.onSubmitClickHandler(this.state.selectedFiles)}>Confirm</button>
            <button type="button" className="btn confirm-button btn-danger" onClick={() => this.props.onCloseButtonClickHandler()}>Close</button>
          </div>
          {(this.props.show_spinner || this.state.loading) ? <div className="spinner"><Loader /></div> : ''}
        </div>
      </ReactModal>
    );
  }

}
